export const LOAD_CONTACT_OF_LIST = 'contacts/LOAD_CONTACT_OF_LIST';
